export const Socket = {
    endpoint: 'https://parafiamistrzejowice.pl/?rest_route=/api/v1/intentions/daily',
    key: 'yZkwgYAQK3CCJn6YADNJqxzfztGzKKNtBMzr5WBzpFBq4tRaS9adJdvSe7zJYrxxcHES9XTewHxMB5sdxcNmW9dNT2c7vDLS65HJ5qZ9BPHwqHW7CQYTkQkLERS2f7Yw'
}